const addTrackingEvent = ({ event, data }) => {
    if (typeof window !== 'undefined' && window.plausible) {
        window.plausible(event, {
            props: data,
        })
    }
}

export default addTrackingEvent
